import { render } from "./TicketsLogs.vue?vue&type=template&id=745bfda7"
import script from "./TicketsLogs.vue?vue&type=script&lang=js"
export * from "./TicketsLogs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__